import { render, staticRenderFns } from "./MailDetail.vue?vue&type=template&id=6c49a58b"
import script from "./MailDetail.vue?vue&type=script&lang=js"
export * from "./MailDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports